import { z } from "zod";

export const BlockIdSchema = z.string().uuidv4();

const BlockTypeSchema = z.enum([
  // Eventual consistency might require a pending block
  "pending",
  // GeoJson types
  "point",
  "multipoint",
  "feature",
  // Routes
  "route",
  "remotegeojson",
]);

export const BlockSchema = z.object({
  id: BlockIdSchema,
  type: BlockTypeSchema,
  attributes: z.record(z.string(), z.any()),
  documentId: z.string(),
  content: z.string().array(),
  deleted: z.boolean().default(false).optional(),
});

const DocumentSchema = z.object({
  id: z.string(),
  name: z.string(),
  blocks: z.array(BlockSchema).optional(),
  createdOn: z.number(),
  owner: z.string(),
  content: BlockIdSchema.array(),
});

export const CachedResultSchema = z.object({
  timestamp: z.number(),
  data: z.any(),
  error: z.string().optional(),
});

export type RenderedDocument = z.infer<typeof DocumentSchema>;
export type RenderedBlock = z.infer<typeof BlockSchema>;
